<div class="home">
  <div class="layout">
    <app-sidebar-menu> </app-sidebar-menu>
  </div>

  <div class="system-setting-scroll-parent">
    <div class="breadcrumb-menu">
      <ng-container *ngIf="selectedShipyardName">
        <div
          class="breadcrumb-menu-item"
          [class.clickable]="selectedVesselData"
          (click)="goToShipyard()">
          <mat-icon svgIcon="folder" class="icon" />
          <div data-cy="breadcrumb-shipyard-name">
            {{ selectedShipyardName }}
          </div>
        </div>
        <ng-container *ngIf="selectedVesselData">
          <mat-icon svgIcon="breadcrumb-chevron" class="icon" />
          <div class="breadcrumb-menu-item" [class.clickable]="selectedPage" (click)="goToVessel()">
            <mat-icon svgIcon="vessel-folder" class="icon" />
            <div data-cy="breadcrumb-vessel-number-and-name">
              {{ selectedVesselData.number }} -
              {{ selectedVesselData.name }}
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="selectedPage">
          <mat-icon svgIcon="breadcrumb-chevron" class="icon" />
          <div class="breadcrumb-menu-item">
            <mat-icon [svgIcon]="pageIcon" class="icon" />
            <div>{{ selectedPage | translate }}</div>
          </div>
        </ng-container>
        <ng-container *ngIf="isDeviceListPage">
          <mat-icon svgIcon="breadcrumb-chevron" class="icon" />
          <div class="breadcrumb-menu-item">
            <div>{{ 'device-list.title' | translate }}</div>
          </div>
        </ng-container>
      </ng-container>
    </div>

    <div class="main">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
